import IEmailSubscriptionEndpoints from "./framework/IEmailSubscriptionEndpoints";
import EndpointsBaseClass from "apiConsumers/EndpointsBaseClass";
import EmailSubscriptionListType from "models/EmailSubscriptionListType";

export default class EmailSubscriptionEndpoints extends EndpointsBaseClass
    implements IEmailSubscriptionEndpoints {
    public async postEmail(
        email: string,
        list: EmailSubscriptionListType,
        termsLabel?: string
    ): Promise<any> {
        let url = "/subscribe";

        const response = await this.makePostRequest(url, {
            emailAddress: email,
            list: list,
            termsAndConditionsText: termsLabel,
        });

        return response;
    }
}
